<template>
  <button
    :style="buttonStyling"
    class="btn"
    :class="dynamicClass"
    :type="type"
    :disabled="disabled || status.loading || status.error"
    @click="!disabled || !status.success ? $emit('click') : null">
    <template v-if="status.loading">
      <span class="snack-loading d-flex mr-1" v-html="svg('loadingConfirm')"></span>
      <slot name="loading"></slot>
    </template>
    <template v-else-if="status.successLoading">
      <span class="snack-loading d-flex mr-1">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 4.33325C8.26522 4.33325 8.51957 4.2279 8.70711 4.04036C8.89464 3.85282 9 3.59847 9 3.33325V1.33325C9 1.06804 8.89464 0.813682 8.70711 0.626145C8.51957 0.438609 8.26522 0.333252 8 0.333252C7.73478 0.333252 7.48043 0.438609 7.29289 0.626145C7.10536 0.813682 7 1.06804 7 1.33325V3.33325C7 3.59847 7.10536 3.85282 7.29289 4.04036C7.48043 4.2279 7.73478 4.33325 8 4.33325Z"
            fill="#fff" />
          <path
            d="M5.51403 4.07074L4.09936 2.65674C3.90857 2.47554 3.65549 2.37451 3.39236 2.37451C3.12924 2.37451 2.87616 2.47554 2.68536 2.65674C2.49789 2.84426 2.39258 3.09857 2.39258 3.36374C2.39258 3.6289 2.49789 3.88321 2.68536 4.07074L4.10003 5.48474C4.19277 5.57776 4.30304 5.65146 4.42445 5.70158C4.54586 5.7517 4.67601 5.77725 4.80736 5.77674C5.00488 5.77643 5.19788 5.71764 5.36203 5.60778C5.52617 5.49792 5.65411 5.34191 5.7297 5.15943C5.80528 4.97695 5.82514 4.77617 5.78676 4.58242C5.74838 4.38867 5.65348 4.21062 5.51403 4.07074Z"
            fill="#fff" />
          <path
            d="M0.333984 8C0.333984 8.26522 0.439341 8.51957 0.626878 8.70711C0.814414 8.89464 1.06877 9 1.33398 9H3.33398C3.5992 9 3.85355 8.89464 4.04109 8.70711C4.22863 8.51957 4.33398 8.26522 4.33398 8C4.33398 7.73478 4.22863 7.48043 4.04109 7.29289C3.85355 7.10536 3.5992 7 3.33398 7H1.33398C1.06877 7 0.814414 7.10536 0.626878 7.29289C0.439341 7.48043 0.333984 7.73478 0.333984 8Z"
            fill="#fff" />
          <path
            d="M4.63758 10.3493C4.50633 10.3488 4.37628 10.3743 4.25498 10.4245C4.13368 10.4746 4.02353 10.5483 3.93091 10.6413L2.51624 12.0559C2.33768 12.2455 2.24011 12.4972 2.24427 12.7576C2.24843 13.018 2.354 13.2665 2.53854 13.4502C2.72307 13.634 2.972 13.7385 3.2324 13.7416C3.4928 13.7446 3.74411 13.646 3.93291 13.4666L5.34758 12.0519C5.48706 11.912 5.58198 11.7339 5.62034 11.5401C5.6587 11.3463 5.63878 11.1455 5.56311 10.9629C5.48744 10.7804 5.3594 10.6244 5.19516 10.5146C5.03091 10.4048 4.83782 10.3461 4.64024 10.3459L4.63758 10.3493Z"
            fill="#fff" />
          <path
            d="M7 14.6667C7 14.932 7.10536 15.1863 7.29289 15.3739C7.48043 15.5614 7.73478 15.6667 8 15.6667C8.26522 15.6667 8.51957 15.5614 8.70711 15.3739C8.89464 15.1863 9 14.932 9 14.6667V12.6667C9 12.4015 8.89464 12.1472 8.70711 11.9596C8.51957 11.7721 8.26522 11.6667 8 11.6667C7.73478 11.6667 7.48043 11.7721 7.29289 11.9596C7.10536 12.1472 7 12.4015 7 12.6667V14.6667Z"
            fill="#fff" />
          <path
            d="M10.699 10.6708C10.5116 10.8583 10.4063 11.1126 10.4062 11.3778C10.4063 11.643 10.5116 11.8973 10.699 12.0848L12.1137 13.4988C12.3014 13.687 12.5562 13.793 12.822 13.7933C13.0878 13.7937 13.3428 13.6885 13.531 13.5008C13.7193 13.3131 13.8252 13.0583 13.8256 12.7925C13.826 12.5267 13.7207 12.2717 13.533 12.0835L12.115 10.6668C12.0219 10.5739 11.9113 10.5004 11.7897 10.4503C11.6681 10.4002 11.5377 10.3746 11.4062 10.375C11.2747 10.3754 11.1445 10.4017 11.0232 10.4524C10.9018 10.5032 10.7917 10.5774 10.699 10.6708Z"
            fill="#fff" />
          <path
            d="M15.666 8C15.666 7.73478 15.5607 7.48043 15.3731 7.29289C15.1856 7.10536 14.9312 7 14.666 7H12.666C12.4008 7 12.1464 7.10536 11.9589 7.29289C11.7714 7.48043 11.666 7.73478 11.666 8C11.666 8.26522 11.7714 8.51957 11.9589 8.70711C12.1464 8.89464 12.4008 9 12.666 9H14.666C14.9312 9 15.1856 8.89464 15.3731 8.70711C15.5607 8.51957 15.666 8.26522 15.666 8Z"
            fill="#fff" />
          <path
            d="M12.6967 2.27344C12.5654 2.27295 12.4354 2.2985 12.3141 2.34862C12.1928 2.39875 12.0826 2.47244 11.99 2.56544L10.5767 3.97878C10.4836 4.07166 10.4098 4.18197 10.3595 4.3034C10.3091 4.42482 10.2832 4.55499 10.2832 4.68644C10.2832 4.8179 10.3091 4.94807 10.3595 5.06949C10.4098 5.19092 10.4836 5.30123 10.5767 5.39411C10.7642 5.58158 11.0185 5.6869 11.2837 5.6869C11.5488 5.6869 11.8031 5.58158 11.9907 5.39411L13.4047 3.98078C13.5446 3.84088 13.64 3.6626 13.6786 3.4685C13.7172 3.27439 13.6973 3.0732 13.6215 2.89039C13.5457 2.70758 13.4174 2.55138 13.2527 2.44155C13.0881 2.33173 12.8946 2.27322 12.6967 2.27344Z"
            fill="#fff" />
        </svg>
      </span>
      <slot name="successLoading"></slot>
    </template>

    <template v-else-if="status.success">
      <span class="d-flex mr-1">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5714 0.289237C11.8259 0.467395 11.8878 0.818132 11.7097 1.07263L4.66841 11.1311C4.16697 11.8509 3.17656 12.0289 2.45643 11.5277C2.31644 11.4303 2.19305 11.311 2.09099 11.1743L0.300054 8.78671C0.113643 8.5382 0.163988 8.18562 0.412505 7.99921C0.661021 7.8128 1.0136 7.86314 1.20001 8.11166L2.9922 10.5009C3.02202 10.5409 3.0581 10.5758 3.09905 10.6043C3.3094 10.7507 3.59861 10.6988 3.74501 10.4885L3.7459 10.4872L10.788 0.427466C10.9662 0.172967 11.3169 0.11108 11.5714 0.289237Z"
            fill="#06E884" />
        </svg>
      </span>
      <slot name="success"></slot>
    </template>
    <template v-else-if="status.error">
      <slot name="error"></slot>
    </template>
    <slot v-else> </slot>
  </button>
</template>

<script>
import { svg as _svg } from '@/app/editor/sidebar/utils/actions.assets';

export default {
  name: 'ProcessButton',
  props: {
    buttonStyling: {
      type: Object,
      default: () => {},
    },
    status: Object,
    default: {
      type: String,
      default: 'btn-primary',
    },
    success: {
      type: String,
      default: 'btn-primary',
    },
    successLoading: {
      type: String,
      default: 'btn-primary',
    },
    error: {
      type: String,
      default: 'btn-danger',
    },
    loading: {
      type: String,
      default: 'btn-secondary',
    },
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    dynamicClass() {
      if (this.status.loading) return this.loading;
      if (this.status.success) return this.success;
      if (this.status.error) return this.error;
      return this.default;
    },
  },
  methods: {
    svg(name) {
      return _svg(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.snack-loading {
  animation: cog 1s infinite;
}
@keyframes cog {
  100% {
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
